export const TILE_GRANULARITY = 16;
